export const delay = (fn, time) => time
    ? new Promise((resolve) => {
        setTimeout(() => {
            fn().then((d) => resolve(d));
        }, time);
    })
    : Promise.resolve(fn());
export const wait = (millis) => millis
    ? new Promise((resolve) => {
        setTimeout(resolve, millis);
    })
    : Promise.resolve();
